import React from "react"

export const XopowoStatsDisplay = props => {
  // console.log(props)
  let visible = ''

  if (props.show) visible = "visible"
  else visible = "hidden"
  
  return (
    <React.Fragment>
        <div className="statsPad statsPad1">
          <div className={visible}>
            {props.usedStats.pad1}
          </div>
        </div>

        <div className="statsPad statsPad2">
          <div className={visible}>
            {props.usedStats.pad2}
          </div>
        </div>

        <div className="statsPad statsPad3">
          <div className={visible}>
            {props.usedStats.pad3}
          </div>
        </div>

        <div className="statsPad statsPad4">
          <div className={visible}>
            {props.usedStats.pad4}
          </div>
        </div>

        <div className="statsPad statsPad5">
          <div className={visible}>
            {props.usedStats.pad5}
          </div>
        </div>

        <div className="statsPad statsPad6">
          <div className={visible}>
            {props.usedStats.pad6}
          </div>
        </div>

        <div className="statsPad statsPad7">
          <div className={visible}>
            {props.usedStats.pad7}
          </div>
        </div>

        <div className="statsPad statsPad8">
          <div className={visible}>
            {props.usedStats.pad8}
          </div>
        </div>

        <div className="statsPad statsPad9">
          <div className={visible}>
            {props.usedStats.pad9}
          </div>
        </div>
    </React.Fragment>
  )
}